

    <div class="table-responsive" *ngIf="pendingQuizEnvelops">
       <table datatable class="row-border hover table table-striped display compact" [dtOptions]="dtOptions"  id="myPendingQuizDataTable" width="100%">
                   <thead>
                   <tr>
                      <th>Id</th>
                      <th>Date Created</th>
                      <th>Subject Name</th>
                      <th>Questions</th>
                      <th>Is Completed</th>
                      <th>Work sheet</th>
                   </tr>
                   </thead>

                   <tbody>

                       <tr *ngFor="let quizEnvelop of pendingQuizEnvelops">
                       <td>{{quizEnvelop.server_quiz_envelop_id}}</td>
                       <td>{{quizEnvelop.datecreated}}</td>
                       <td>{{quizEnvelop.subjectName}}</td>
                       <td>
                           <a *ngIf="quizEnvelop.question_count>0" [routerLink]="['/student/quiz/show',server_student_user_id,quizEnvelop.server_quiz_envelop_id]">
                               Quiz ({{quizEnvelop.question_count}})
                           </a>

                           <button  *ngIf="quizEnvelop.question_count==0" class="btn btn-link" (click)="deleteQuiz(quizEnvelop.server_quiz_envelop_id)">
                            Quiz ({{quizEnvelop.question_count}})
                           </button>
                       </td>
                       <td class="text-center"> {{quizEnvelop.isCompleted? 'Yes':'No'}}</td>
                       <td class="text-center">

                           <button  (click)="downloadPdf(quizEnvelop.server_quiz_envelop_id)">
                            <i *ngIf="!(loading && (downloading==quizEnvelop.server_quiz_envelop_id))" class='fa fa-file-pdf-o'></i>
                            <span *ngIf="(loading && (downloading==quizEnvelop.server_quiz_envelop_id))" class="spinner-border spinner-border-lg me-1 text-primary"></span>
                           </button>

                       </td>
                       </tr>
                   </tbody>

          </table>
       </div>
       <div *ngIf="pendingQuizEnvelops && pendingQuizEnvelops.length==0" class="alert alert-info text-center">  No Pending Quiz </div>
       <app-spinner *ngIf="loadingEnvelops"> </app-spinner>
       <fieldset class="text-center mt-4" *ngIf="server_student_user_id!=0">
        <hr/>
       <button  class="btn btn-primary me-2"  (click)="trialAlertPendingMaxAlert()">
           <i class="fa fa-plus"></i> Pick Another Quiz for {{subscription.name}}
        </button>
       <a [routerLink]="['/area/quiz/modify',server_student_user_id]" class='btn btn-outline-primary me-2'> Change Quiz Area </a>
       <a  *ngIf="authService.isGranted('ROLE_GUARDIAN')" [routerLink]="['/guardian/show',learner.server_guardian_user_id]"   class="btn btn-primary"><i class="fa fa-close"></i> Close</a>
       </fieldset>
       <app-enrol-upgrade *ngIf="server_enrolment_id!=0" [learner]="learner"  [guardian]="guardian"></app-enrol-upgrade>



